// media-query rules for window.matchMedia()
export default [
  {
    id: 'large',
    minWidth: 980
  }
];



// WEBPACK FOOTER //
// ./src/views/media.js